// Função para iniciar o swiper conforme a largura da tela
function iniciarSwiperResponsivo() {
  const swiperMobileEl = document.querySelector('#banner-slide-mobile');
  const swiperDesktopEl = document.querySelector('#banner-slide-desktop');

  if (window.innerWidth < 750 && swiperMobileEl) {
    const delay = parseFloat(swiperMobileEl.dataset.tempodelay || "5") * 1000;
    new Swiper('#banner-slide-mobile', {
      slidesPerView: 1,
      pagination: {
        el: "#banner-bloco-pagination-mobile",
        clickable: true
      },
      effect: "fade",
      autoplay: {
        delay: delay,
        disableOnInteraction: true
      },
      loop: true
    });
  }

  if (window.innerWidth >= 750 && swiperDesktopEl) {
    const delay = parseFloat(swiperDesktopEl.dataset.tempodelay || "5") * 1000;
    new Swiper('#banner-slide-desktop', {
      slidesPerView: 1,
      pagination: {
        el: "#banner-bloco-pagination-desktop",
        clickable: true
      },
      effect: "fade",
      autoplay: {
        delay: delay,
        disableOnInteraction: true
      },
      loop: true
    });
  }
}

// Garante que a função só rode após o carregamento da página
document.addEventListener('DOMContentLoaded', iniciarSwiperResponsivo);
